import { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import TeethToExtract from '../TeethToExtract';

type RhfTeethToExtractProp = {
  name: string;
  title?: string;
  titleClassName?: string;
  showError?: boolean;
  disabled?: boolean;
  animateLabel?: string;
  source?: string;
};
const RhfTeethToExtract: FC<RhfTeethToExtractProp> = ({
  name,
  title,
  titleClassName,
  showError = true,
  disabled = false,
  animateLabel,
  source
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TeethToExtract
          source={source}
          title={title}
          titleClassName={titleClassName}
          value={field.value}
          onChange={field.onChange}
          name={name}
          error={error?.message}
          showError={showError}
          disabled={disabled}
          animateLabel={animateLabel}
        />
      )}
    />
  );
};

export default RhfTeethToExtract;
